<template>
  <v-card>
    <v-row>
      <v-col>
        <v-card-title>Filters</v-card-title>
      </v-col>
    </v-row>
    <v-row class="mx-3">
      <v-col cols="6">
        <v-row class="mx-3">
          <v-col cols="4">
            <v-select v-model="filters.status" label="Status" :items="options.status" />
          </v-col>
          <v-col cols="4">
            <v-select v-model="filters.clientType" label="Client Type" :items="options.clientType" />
          </v-col>
          <v-col cols="4">
            <v-select v-model="filters.staff" label="Staff" :items="options.staff" />
          </v-col>
        </v-row>
        <v-row class="mx-3">
          <v-col cols="4">
            <v-dialog
              ref="registeredBeforeDialogRef"
              v-model="registeredBeforeDialog"
              :return-value.sync="filters.registeredBefore"
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="filters.registeredBefore"
                  label="Joined JEFF Before"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="filters.registeredBefore" scrollable>
                <v-spacer></v-spacer>
                <v-btn
                  text
                  @click="
                    filters.registeredBefore = null;
                    registeredBeforeDialog = false;
                    $refs.registeredBeforeDialogRef.save(filters.registeredBefore);
                  "
                  >Clear</v-btn
                >
                <v-btn text color="primary" @click="$refs.registeredBeforeDialogRef.save(filters.registeredBefore)">
                  OK
                </v-btn>
              </v-date-picker>
            </v-dialog>
          </v-col>
          <v-col cols="4">
            <v-dialog
              ref="registeredAfterDialogRef"
              v-model="registeredAfterDialog"
              :return-value.sync="filters.registeredAfter"
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="filters.registeredAfter"
                  label="Joined JEFF After"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="filters.registeredAfter" scrollable>
                <v-spacer></v-spacer>
                <v-btn
                  text
                  @click="
                    filters.registeredAfter = null;
                    registeredAfterDialog = false;
                    $refs.registeredAfterDialogRef.save(filters.registeredBefore);
                  "
                  >Clear</v-btn
                >
                <v-btn text color="primary" @click="$refs.registeredAfterDialogRef.save(filters.registeredAfter)">
                  OK
                </v-btn>
              </v-date-picker>
            </v-dialog>
          </v-col>
          <v-col cols="4">
            <v-select v-model="filters.coach" label="Coach" multiple clearable :items="coaches" />
          </v-col>
        </v-row>
        <v-row class="mx-3">
          <v-col cols="4">
            <v-select v-model="filters.productTypes" label="Product Type" multiple :items="options.productTypes" />
          </v-col>
          <v-col cols="4">
            <v-select v-model="filters.primaryGoal" label="Primary Goal" multiple clearable :items="options.goals" />
          </v-col>
          <v-col cols="4">
            <v-select v-model="filters.engagement" label="Engagement" :items="[0, 20, 40, 60, 80, 100]" />
          </v-col>
        </v-row>
        <v-row class="mx-3">
          <v-col cols="4">
            <v-autocomplete
              v-model="filters.nutritionBlocks"
              label="Currently on Menu"
              multiple
              clearable
              chips
              deletable-chips
              :items="getBlockOptionsByType('NUTRITION')"
            />
          </v-col>
          <v-col cols="4">
            <v-autocomplete
              v-model="filters.courseBlocks"
              label="Currently on Course"
              multiple
              clearable
              chips
              deletable-chips
              :items="getBlockOptionsByType('COURSE')"
            />
          </v-col>
          <v-col cols="4">
            <v-autocomplete
              v-model="filters.previousCourseBlocks"
              label="Has completed courses"
              multiple
              clearable
              chips
              deletable-chips
              :items="getBlockOptionsByType('COURSE')"
            />
          </v-col>
        </v-row>
        <v-row class="mx-3">
          <v-col cols="6">
            <v-select
              v-model="filters.hasCheckinInLast"
              label="Has checkin in period"
              :items="options.hasCheckinInLastPeriodTypes"
            />
          </v-col>
          <v-col cols="6">
            <v-select
              v-model="filters.lastWorkoutInstructor"
              label="Last workout with instructor"
              multiple
              clearable
              :items="coaches"
            />
          </v-col>
        </v-row>
        <v-row class="mx-3">
          <v-col cols="6">
            <v-text-field
              v-model="filters.bulkMessage7dayMax"
              label="Max bulk messages received (last 7 days)"
              placeholder="0"
            />
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="6">
        <v-row class="mx-3">
          <v-col cols="12">
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header><strong>Program Filter</strong></v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card flat>
                    <v-row>
                      <v-col cols="12" class="px-5 py-0">
                        <v-autocomplete
                          class="pt-0"
                          v-model="filters.workoutBlocks.blockIds"
                          label="Programs"
                          multiple
                          clearable
                          chips
                          deletable-chips
                          :items="getBlockOptionsByType(['PROGRAM', 'CHALLENGE'])"
                        />
                        <v-select
                          v-model="filters.workoutBlocks.isCompleted"
                          :items="options.blockCompletedTypes"
                          label="Completed"
                        />
                        <v-select
                          v-model="filters.workoutBlocks.startType"
                          :items="options.blockStartDateTypes"
                          label="Start Date"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6" class="px-5 py-0">
                        <v-text-field
                          v-model="filters.workoutBlocks.workoutsCompletedMin"
                          label="Min Workouts completed"
                        />
                      </v-col>
                      <v-col cols="6" class="px-5 py-0">
                        <v-text-field
                          v-model="filters.workoutBlocks.workoutsCompletedMax"
                          label="Max Workouts completed"
                        />
                      </v-col>
                    </v-row>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header><strong>Workouts Logged</strong></v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card flat>
                    <v-row>
                      <v-col cols="12" class="px-5 py-0">
                        <v-select
                          v-model="filters.numberOfWorkoutsLogged.days"
                          :items="[30, 60]"
                          label="In last days"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6" class="px-5 py-0">
                        <v-text-field v-model="filters.numberOfWorkoutsLogged.min" label="Between" />
                      </v-col>
                      <v-col cols="6" class="px-5 py-0">
                        <v-text-field v-model="filters.numberOfWorkoutsLogged.max" label="And" />
                      </v-col>
                    </v-row>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header><strong>Nutrition Logged</strong></v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card flat>
                    <v-row>
                      <v-col cols="12" class="px-5 py-0">
                        <v-select
                          v-model="filters.numberOfNutritionDotsLogged.days"
                          :items="[30, 60]"
                          label="In last days"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6" class="px-5 py-0">
                        <v-text-field v-model="filters.numberOfNutritionDotsLogged.min" label="Between" />
                      </v-col>
                      <v-col cols="6" class="px-5 py-0">
                        <v-text-field v-model="filters.numberOfNutritionDotsLogged.max" label="And" />
                      </v-col>
                    </v-row>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header><strong>Last Subscription End</strong></v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card flat>
                    <v-row>
                      <v-col cols="12" class="px-5 py-0">
                        <v-text-field
                          v-model="filters.lastSubscription.before"
                          label="Before"
                          placeholder="YYYY-MM-DD"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" class="px-5 py-0">
                        <v-text-field v-model="filters.lastSubscription.after" label="After" placeholder="YYYY-MM-DD" />
                      </v-col>
                    </v-row>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header><strong>Rewards Points</strong></v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card flat>
                    <v-row>
                      <v-col cols="12" class="px-5 py-0">
                        <v-text-field v-model="filters.rewardsPoints.min" label="Min" placeholder="0" />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" class="px-5 py-0">
                        <v-text-field v-model="filters.rewardsPoints.max" label="Max" placeholder="0" />
                      </v-col>
                    </v-row>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header><strong>Weight Loss</strong></v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card flat>
                    <v-row>
                      <v-col cols="12" class="px-5 py-0">
                        <v-text-field v-model="filters.weightLossGoal.min" label="Min" placeholder="0" />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" class="px-5 py-0">
                        <v-text-field v-model="filters.weightLossGoal.max" label="Max" placeholder="0" />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" class="px-5 py-0">
                        <v-select
                          v-model="filters.weightLossGoal.source"
                          :items="options.weightLossGoalSourceTypes"
                          label="Source"
                        />
                      </v-col>
                    </v-row>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { SIMPLE_COACHES_QUERY } from "@/constants/graphql/coach/clientManagement";
import { getUserName } from "@/lib/username";
import { WORKOUT_BLOCKS_QUERY } from "@/constants/graphql/blocks/workoutblocks";
import { extractNodes } from "@/lib/array";
import { NUTRITION_BLOCKS_QUERY } from "@/graphql/queries/nutrition";
import { decodeId } from "@/lib/string";

export default {
  name: "UserFilter",
  data() {
    return {
      workoutBlocks: [],
      nutritionBlocks: [],
      registeredAfterDialog: false,
      registeredBeforeDialog: false,
      filters: {
        status: true,
        clientType: "customer",
        staff: false,
        productTypes: ["one-on-one", "club"],
        coach: null,
        workoutBlocks: {
          blockIds: [],
          isCompleted: null,
          startType: null,
          workoutsCompletedMin: null,
          workoutsCompletedMax: null,
        },
        courseBlocks: [],
        previousCourseBlocks: [],
        nutritionBlocks: [],
        lastWorkoutInstructor: null,
        primaryGoal: null,
        engagement: null,
        registeredBefore: null,
        registeredAfter: null,
        numberOfWorkoutsLogged: {
          days: null,
          min: 0,
          max: 0,
        },
        numberOfNutritionDotsLogged: {
          days: null,
          min: 0,
          max: 0,
        },
        lastSubscription: {
          before: null,
          after: null,
        },
        rewardsPoints: {
          min: 0,
          max: 0,
        },
        weightLossGoal: {
          min: 0,
          max: 0,
          source: "last_checkin",
        },
        hasCheckinInLast: null,
      },
      options: {
        status: [
          { text: "Active", value: true },
          { text: "In-Active", value: false },
        ],
        clientType: [
          { text: "Customer", value: "customer" },
          { text: "Corporate", value: "corporate" },
        ],
        staff: [
          { text: "Yes", value: true },
          { text: "No", value: false },
        ],
        productTypes: [
          { text: "1-on-1", value: "one-on-one" },
          { text: "Club", value: "club" },
          { text: "LIFE", value: "jeff-member" },
        ],
        coaches: [],
        goals: ["lose-weight", "strengthen-tone", "running", "healthy-pregnancy", "get-fit"],
        blockCompletedTypes: [
          { text: "Completed or currently in progress", value: null },
          { text: "Completed", value: true },
          { text: "In Progress", value: false },
        ],
        blockStartDateTypes: [
          { text: "Any start date", value: null },
          { text: "On program start date", value: "onStartDate" },
          { text: "Before program started", value: "beforeStartDate" },
          { text: "After program started", value: "afterStartDate" },
        ],
        weightLossGoalSourceTypes: [
          { text: "Latest checkin in last 3 months", value: "last_checkin" },
          { text: "Values in user profile", value: "user_profile" },
        ],
        hasCheckinInLastPeriodTypes: [
          { text: "", value: null },
          { text: "Last 30 Days", value: 30 },
          { text: "Last 60 Days", value: 60 },
          { text: "Last 90 Days", value: 90 },
        ],
        bulkMessage7dayMax: 0,
      },
    };
  },
  methods: {
    getBlockOptionsByType(type = "PROGRAM") {
      let types = type;
      if (!type instanceof Array) {
        types = [type];
      }
      if (["PROGRAM", "COURSE", "CHALLENGE"].some(element => types.includes(element))) {
        return this.workoutBlocks
          .filter((element) => types.includes(element.type))
          .map((element) => {
            return {
              value: element.blockId,
              text: element.title,
            };
          });
      } else {
        return this.nutritionBlocks.map((element) => {
          return {
            value: decodeId(element.id),
            text: element.title,
          };
        });
      }
    },
  },
  apollo: {
    coaches: {
      query: SIMPLE_COACHES_QUERY,
      fetchPolicy: "cache-and-network",
      variables() {
        return {
          includeCurrentCoach: true,
        };
      },
      update(data) {
        return data.simpleCoaches.map((element) => {
          return {
            value: element.id,
            text: getUserName(element),
          };
        });
      },
    },
    workoutBlocks: {
      query: WORKOUT_BLOCKS_QUERY,
      fetchPolicy: "cache-and-network",
      update(data) {
        return extractNodes(data.workoutBlocks.edges);
      },
    },
    nutritionBlocks: {
      query: NUTRITION_BLOCKS_QUERY,
      fetchPolicy: "cache-and-network",
      update(data) {
        return extractNodes(data.nutritionBlocks.edges);
      },
    },
  },
};
</script>
